import { Box, Typography } from '@mui/material';
import Logo from './Logo';

export const FSPAdminHeader: React.FC<{}> = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1.5,
      }}
    >
      <Logo />
      <Typography
        variant="h2"
        component="div"
        sx={{
          color: 'primary.main',
          fontWeight: 700,
          letterSpacing: '-0.5px',
          textShadow: '0 2px 4px rgba(79, 70, 229, 0.1)',
        }}
      >
        <Box component="span" sx={{ color: 'primary.light' }}>
          ADMIN
        </Box>
      </Typography>
    </Box>
  );
};
export default FSPAdminHeader;
